/* terminal/reducer */
import { createReducer } from "typesafe-actions";
import { TerminalActionTypes, TerminalState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveBulk,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
  uploadFile,
  uploadFileSuccess,
  uploadFileError,
  updateState
} from "./actions";

export const initialState: TerminalState = {
  data: undefined,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveBulk>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>
  | ReturnType<typeof uploadFile>
  | ReturnType<typeof uploadFileSuccess>
  | ReturnType<typeof uploadFileError>
  | ReturnType<typeof updateState>;

export default createReducer<TerminalState, ActionType>(initialState)
  .handleType(TerminalActionTypes.FETCH, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(TerminalActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(TerminalActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload
    };
  })
  .handleType(TerminalActionTypes.SAVE_REQUEST, state => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(TerminalActionTypes.SAVE_BULK, state => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(TerminalActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(TerminalActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload
    };
  })
  .handleType(TerminalActionTypes.DELETE_REQUEST, state => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(TerminalActionTypes.DELETE_SUCCESS, state => {
    return {
      ...state,
      loading: false,
      errors: undefined
    };
  })
  .handleType(TerminalActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload
    };
  })
  .handleType(TerminalActionTypes.UPLOAD_FILE, state => {
    return { ...state, uploading: true, errors: undefined };
  })
  .handleType(TerminalActionTypes.UPLOAD_FILE_SUCCESS, (state, action) => {
    return {
      ...state,
      uploading: false,
      uploadedData: action.payload,
      errors: undefined
    };
  })
  .handleType(TerminalActionTypes.UPLOAD_FILE_ERROR, (state, action) => {
    return {
      ...state,
      uploading: false,
      errors: action.payload
    };
  })
  .handleType(TerminalActionTypes.UPDATE_STATE, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
      data: {
        errors: undefined,
        data: action.payload,
        meta: {
          totalObjects: action.payload.length
        }
      }
    };
  });
